"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledActionChip = exports.StyledChip = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const variants_1 = require("../../themes/variants");
exports.StyledChip = styled_components_1.default.span.withConfig({
    shouldForwardProp: (prop) => !["variant", "outlined", "disabled"].includes(prop),
}) `
  font-family: AvantGarde;
  font-weight: 400;
  border-radius: 3.125rem;
  font-size: 0.875rem;
  line-height: 1.5;
  padding: 0.25rem 0.75rem 0.25rem 0.75rem;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${(_a) => {
    var { outlined } = _a, props = __rest(_a, ["outlined"]);
    const textColor = outlined
        ? (0, variants_1.variantTextColor)(props)
        : (0, variants_1.variantBgColor)(props);
    const backColor = outlined
        ? (0, variants_1.variantBgColor)(props)
        : (0, variants_1.variantTextColor)(props);
    const borderColor = outlined ? textColor : backColor;
    return (0, styled_components_1.css) `
      background-color: ${backColor};
      color: ${textColor};
      border: 0.03rem solid ${borderColor};
    `;
}};
`;
exports.StyledActionChip = (0, styled_components_1.default)(exports.StyledChip) `
  & {
    padding-right: 2rem;
    position: relative;
    cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
    [data-testid="chip-icon"] {
      position: absolute;
      right: 0.5rem;
      top: 50%;
      transform: translateY(-50%);
      font-size: 1.125rem;
      margin-left: 0.5rem;
    }
  }
`;
//# sourceMappingURL=styled.js.map